import type en from "../en/ai";
import type { Translation } from "../../types";

const ai: Translation<typeof en> = {
  chat: {
    untitled: "Sans titre",
    newConversation: "Nouvelle discussion",
    emptyTitle: "Posez une question sur cette réunion",
    emptyBody:
      "Les réponses citent les moments dont elles sont tirées — cliquez sur l’un d’eux pour vous y rendre.",
    placeholder: "Posez une question sur cette réunion…",
    deleteQuestion: "Supprimer cette question et sa réponse",
    deleteAnswer: "Supprimer cette réponse",
    couldNotOpen: "Impossible d’ouvrir cette discussion.",
    unavailable: "La discussion est indisponible pour le moment.",
    somethingWrong: "Un problème est survenu.",
    when: {
      justNow: "à l’instant",
      minutesAgo: "il y a {{count}} min",
      hoursAgo: "il y a {{count}} h",
      daysAgo: "il y a {{count}} j",
    },
    history: {
      title: "Discussions",
      close: "Fermer l’historique",
      empty:
        "Aucune discussion pour l’instant. Posez une question : elle sera enregistrée ici, nommée d’après ce que vous avez demandé.",
      saveName: "Enregistrer le nom",
      confirmDelete: "Supprimer ?",
      deleteConversation: "Supprimer la discussion",
    },
  },
  summary: {
    title: "Résumé",
    askedBy: "· demandé par {{name}}",
    generating: "Génération…",
    regenerate: "Régénérer",
    generate: "Générer le résumé",
    noTranscript:
      "Cet enregistrement n’a pas encore de transcription : il n’y a donc rien à résumer.",
    none: "Aucun résumé pour l’instant. Pour en générer un, le modèle de votre espace de travail lit toute la transcription et en extrait ce qui a été décidé, ce que chacun a pris en charge et ce qui est resté sans réponse. Tous les membres de l’espace de travail voient le résultat.",
    failed: "Le résumé n’a pas pu être généré.",
    reading: "Lecture de la transcription. Cela prend généralement moins d’une minute.",
    couldNotStart: "Impossible de lancer la génération.",
    tabs: {
      overview: "Vue d’ensemble",
      decisions: "Décisions",
      actions: "Actions",
      questions: "Questions ouvertes",
    },
    keyPoints: "Points clés",
    noDecisions: "Rien n’a été tranché lors de cette réunion.",
    noActions: "Personne n’a pris d’engagement.",
    unassigned: "Non attribuée",
    noQuestions: "Aucune question n’est restée en suspens.",
    askedByPerson: "posée par {{name}}",
    jumpToSpeaker: "Aller à {{speaker}} à {{time}}",
    jumpTo: "Aller à {{time}}",
  },
  export: {
    title: "Exporter",
    downloadOriginal: "Télécharger l’original",
    downloadOriginalDetail: "La vidéo telle qu’enregistrée, sans sous-titres. Immédiat.",
    burnedLegend: "Exporter avec sous-titres incrustés",
    noTranscript:
      "Cet enregistrement n’a pas encore de transcription, il n’y a donc pas de sous-titres à incruster. Transcrivez-le d’abord depuis le panneau de transcription.",
    translationsFailed: "Impossible de charger les traductions.",
    originalLanguage: "Langue d’origine",
    originalDetail: "La transcription telle que prononcée.",
    languageLabel: "{{name}} · {{native}}",
    translationReady: "Traduction prête.",
    translating: "Traduction en cours…",
    translationFailed: "La traduction a échoué.",
    cancelTitle: "Arrêter cette traduction — la facturation s’arrête au prochain lot",
    retryTitle: "Traduire la transcription avec le modèle d’IA de l’espace de travail",
    addLanguage: "Ajouter une langue…",
    translate: "Traduire",
    translateFirst: "Traduisez d’abord cette langue, puis exportez.",
    exportTitle: "Réencode la vidéo avec les sous-titres choisis incrustés",
    exportVideo: "Exporter la vidéo",
    exportsFailed: "Impossible de charger les exports précédents.",
    exports: "Exports",
    encoding: "Encodage…",
    translationCancelled: "Traduction annulée.",
    exportStarted: "Export lancé — il apparaîtra ci-dessous une fois prêt.",
  },
  search: {
    placeholder: "Rechercher dans toutes les réunions…",
    hint: "Essayez une phrase dont vous vous souvenez. Les expressions entre guillemets fonctionnent, tout comme <mono>-mot</mono> pour en exclure un.",
    failed: "La recherche n’a pas fonctionné",
    emptyTitle: "Aucun résultat",
    emptyBody: "Aucune réunion ne mentionne cela. Essayez avec moins de mots ou des mots différents.",
  },
};

export default ai;
